import { useField } from 'formik';
import React from 'react';

import IconList from '../IconList';
import type { FormikIconListProps } from '../interfaces';

const FormikIconList: React.FC<FormikIconListProps> = ({ name, multi, items, ...rest }) => {
  const [field, meta, helpers] = useField(name);

  const error = meta.touched && meta.error;

  const setValue = (id: string) =>
    helpers.setValue(
      multi
        ? field.value.indexOf(id) > -1
          ? field.value.filter(v => v !== id)
          : [...field.value, id]
        : id
    );

  const itemsWithChange = items.map(item => ({
    ...item,
    onChange: () => {
      if (item.onChange) {
        item.onChange();
      }
      setValue(item.value);
    }
  }));

  return (
    <IconList {...rest} name={name} items={itemsWithChange} selected={field.value} error={error} />
  );
};

export default FormikIconList;
